import {
  MediaTypePostEditorState,
  PostEditorPostError,
  PostEditorPostErrors,
  PostGroupsType
} from '../../../models/post-editor';
import { ErrorMessageSeverity } from '../../../constants/form';
import { mediaContainsVideo } from '../helpers/mediaContainsVideo';
import { severityResolver } from './helpers/severity-resolver';
import { PostEditorValidationMessages } from '../constants/validation-messages';
import { SelectedSocialProfileValue } from '../../../components/socialProfiles/SocialProfileSelectorList/SocialProfileSelectorList.view';
import { countSymbols } from '../../../helpers/countSymbols';

const hasTitle = (profiles: SelectedSocialProfileValue[], media: MediaTypePostEditorState[]): boolean =>
  profiles.reduce((prev, curr) => {
    if (prev) return prev;
    switch (curr.__typename) {
      case 'PinterestSocialProfile':
        return true;
      case 'FacebookSocialProfile':
      case 'TwitterSocialProfile':
      case 'LinkedInSocialProfile':
        return mediaContainsVideo(media);
      default:
        return false;
    }
  }, false);

const isInvalid = (title: string): boolean => countSymbols(title) > 100;

export const titleCharLimit = (postGroup: PostGroupsType, severity: ErrorMessageSeverity): PostEditorPostErrors => {
  const { customizeContentPerProfile, profiles } = postGroup;
  let results: PostEditorPostError[] = [];
  if (customizeContentPerProfile) {
    postGroup.posts.forEach(post => {
      const { media, title } = post.content;
      const selectedSocialProfiles = profiles.filter(p => p.profileId === post.customizedProfileId);

      if (hasTitle(selectedSocialProfiles, media) && title && isInvalid(title)) {
        results = [
          ...results,
          {
            profileId: post.customizedProfileId,
            variationId: null,
            severity: severityResolver(post, severity),
            selectedSocialProfiles,
            message: PostEditorValidationMessages.titleCharLimit
          }
        ];
      }
    });
    return results.length ? results : false;
  } else {
    const { media, title } = postGroup.groupPostAttributes.content;
    const selectedSocialProfiles = profiles.filter(
      p =>
        p.__typename === 'PinterestSocialProfile' ||
        (p.__typename &&
          ['FacebookSocialProfile', 'TwitterSocialProfile', 'LinkedInSocialProfile'].includes(p.__typename) &&
          mediaContainsVideo(media))
    );
    return hasTitle(profiles, media) && title && isInvalid(title)
      ? {
          profileId: null,
          variationId: null,
          severity: severityResolver(postGroup.groupPostAttributes, severity),
          selectedSocialProfiles,
          message: PostEditorValidationMessages.titleCharLimit
        }
      : false;
  }
};
